import { useEffect, useState } from "react"
import Accordion from "../campusLife/accordion"
import useFetch from "../../utils/useFetch"
import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../../utils/decodeHtml";

const PaymentPopUp = ({ url }) => {


    const data = useFetch(url)
    const payment = data?.properties

    const title = payment?.title
    const [accordion, setAccordion] = useState([])

    useEffect(() => {
        setAccordion(
            payment?.accordions?.items?.map(item => {
                item = item?.content?.properties
                return ({
                    question: item?.label,
                    answer: DecodeHtml({ html: item?.accordionContent?.markup }),
                    isOpen: false
                })
            }
            )
        )
    }, [payment?.accordions])
  
    return (
        <div className="flex flex-col gap-8 w-full p-2 md:p-8 max-h-[80vh] max-w-[80vw]  overflow-y-auto scroll-bar">
            <h1 className=" text-zinc-950 text-xl sm:text-[3rem] font-bold">{title}</h1>
            <Accordion accordion={accordion} setAccordion={setAccordion} />
        </div>
    )
}
PaymentPopUp.propTypes = {
    url: PropTypes.any
}
export default PaymentPopUp